module.exports = __webpack_public_path__ + "static/media/logo-kingconf.d859010a.png";